import React, { useState, useEffect, useRef } from "react";
import { OnfidoView } from "./onFidoView";
import { Onfido } from "onfido-sdk-ui";
import { X } from "lucide-react";
import ConfirmationDialog from "./confirmation-dialog";

const DocuSignModal = ({
  isOpen,
  onClose,
  docuSignUrl,
  docuSignIframeRef,
  handleDocuSignIframeLoad,
}) => {
  const [showConfirmation, setShowConfirmation] = useState(false);

  // Reset loading state when modal opens
  useEffect(() => {
    if (isOpen) {
      setShowConfirmation(false); // Reset confirmation state when modal opens
    }
  }, [isOpen]);

  // Handle body scroll locking
  // useEffect(() => {
  //   if (isOpen) {
  //     document.body.style.overflow = "hidden";
  //   } else {
  //     document.body.style.overflow = "unset";
  //   }
  //   return () => {
  //     document.body.style.overflow = "unset";
  //   };
  // }, [isOpen]);

  // Handle close button click - show confirmation first
  const handleCloseClick = () => {
    setShowConfirmation(true);
  };

  // Handle confirmation dialog - user confirms close
  const handleConfirmClose = () => {
    setShowConfirmation(false);
    onClose();
  };

  // Handle confirmation dialog - user cancels close
  const handleCancelClose = () => {
    setShowConfirmation(false);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-black bg-opacity-50"
        onClick={handleCloseClick}
      />
      <div className="relative bg-white rounded-lg shadow-xl w-full max-w-6xl max-h-[95vh] flex flex-col">
        <div className="flex items-center justify-between p-1 border-b border-gray-200 flex-shrink-0">
          <h2 className="text-lg font-semibold text-gray-900">
          </h2>
          <button
            onClick={handleCloseClick}
            className="p-2 hover:bg-gray-100 rounded-full transition-colors"
          >
            <X className="w-5 h-5 text-gray-500" />
          </button>
        </div>

        <div className="flex-1 min-h-0 overflow-auto">
          {docuSignUrl && (
            <iframe
              ref={docuSignIframeRef}
              src={docuSignUrl}
              className="w-full min-h-[70vh] border-0"
              title="DocuSign Document"
              onLoad={handleDocuSignIframeLoad}
              sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-top-navigation"
            />
          )}
        </div>

        {/* <div className="p-4 bg-white border-t border-gray-200 rounded-b-lg flex-shrink-0">
          <div className="flex justify-end space-x-3">
            <button
              onClick={closeDocuSignModal}
              className="px-4 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md transition-colors"
            >
              Close
            </button>
          </div>
        </div> */}

        {/* Confirmation Dialog */}
        <ConfirmationDialog
          isOpen={showConfirmation}
          onConfirm={handleConfirmClose}
          onCancel={handleCancelClose}
          heading={"Close E-Signature?"}
          subHeading={"Are you sure you want to close the E-Signature process?"}
        />
      </div>
    </div>
  );
};

export default DocuSignModal;
